import $, { Cash } from 'cash-dom';

/**
 * Home Module
 * Scrolls the page horizontally on trigger click
 */
export default class Home {
    /**
     * Singleton instance of the component
     */
    static #instance: Home;

    /**
     * Cash body reference
     */
    protected $body: Cash;

    /**
     * Cash html reference
     */
    protected $html: Cash;

    /**
     * UI references
     */
    protected ui = {
        homeTrigger: '.js-home-trigger',
    };

    /**
     * Constructor
     */
    protected constructor() {
        this.$body = $('body');
        this.$html = $('html');
        this.registerEvents();
    }

    /**
     * Returns the singleton instance of the component
     */
    public static getInstance(): Home {
        if (!Home.#instance) {
            Home.#instance = new Home();
        }

        return Home.#instance;
    }

    /**
     * Register required DOM events
     */
    protected registerEvents(): void {
        this.$body.on('click', this.ui.homeTrigger, this.scrollToTarget.bind(this));
    }

    /**
     * Smooth scroll to 65vh with easeOut and class toggle
     */
    protected scrollToTarget(event: Event): void {
        event.preventDefault();

        const targetY = window.innerHeight * 0.35;
        const duration = 650; // aligned with home transition

        this.scrollToY(targetY, duration);
    }

    protected scrollToY(targetY: number, duration = 600, callback?: () => void): void {
        const startY = window.scrollY;
        const distance = targetY - startY;
        const startTime = performance.now();

        // Disable CSS smooth scrolling during JS animation
        this.$html.addClass('no-smooth-scroll');
        this.$body.addClass('is-scrolling-home');

        const step = (currentTime: number) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = this.easeOut(progress);

            window.scrollTo(0, startY + distance * eased);

            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                // Re-enable CSS smooth scrolling after animation
                this.$html.removeClass('no-smooth-scroll');

                this.$body.removeClass('is-scrolling-home');

                if (typeof callback === 'function') {
                    callback();
                }
            }
        };

        requestAnimationFrame(step);
    }

    /**
     * EaseOut - starts fast, ends slow (smooth deceleration)
     */
    protected easeOut(t: number): number {
        return 1 - Math.pow(1 - t, 3);
    }
}